export default "__VITE_ASSET__b140f461__"